import { Step } from '~components/wizard-form/props';

import EmailPreview from '~direct-debits/components/bulk-signup-wizard/EmailPreview';
import FiltersPreview from '~direct-debits/components/bulk-signup-wizard/FiltersPreview';
import Review from '~direct-debits/components/bulk-signup-wizard/Review';

export const DEFAULT_SUBJECT = '{{COMPANY_NAME}} - Set up your direct debit';

export const DEFAULT_BODY = `Hi {{FIRST_NAME}},

We'd like to set up a direct debit for your regular payments with us.

Please click the link below to get started:

{{SIGNUP_LINK}}

If you have any questions, please don't hesitate to contact us.

Kind regards,
{{COMPANY_NAME}}`;

const steps: Step[] = [
  {
    step: 1,
    title: 'Filters',
    fields: {
      mandate_filter: {
        type: 'switch',
        caption: 'Mandate Status',
        labels: ['No Mandate', 'All Users'],
        defaultValue: true,
      },
      has_outstanding_invoice: {
        type: 'switch',
        caption: 'Has Outstanding Invoice',
        defaultValue: false,
      },
      has_email: {
        type: 'switch',
        caption: 'Has Email Address',
        defaultValue: true,
        disabled: true,
      },
      last_sent_days: {
        type: 'number',
        caption: 'Not sent in last (days)',
        description:
          'Only include clients who have not been sent a signup link in this many days. Leave blank to include all.',
        colSize: 6,
      },
      preview: {
        type: 'custom',
        caption: 'Preview',
        component: FiltersPreview,
        colSize: 6,
        dependencies: ['mandate_filter', 'has_outstanding_invoice', 'has_email', 'last_sent_days'],
        isAttribute: false,
      },
    },
  },
  {
    step: 2,
    title: 'Email Template',
    fields: {
      subject: {
        type: 'text',
        caption: 'Subject',
        required: true,
        defaultValue: DEFAULT_SUBJECT,
      },
      body: {
        type: 'textarea',
        caption: 'Body',
        required: true,
        defaultValue: DEFAULT_BODY,
        className: 'bulk-signup-body-textarea',
      },
      preview_panel: {
        type: 'custom',
        caption: 'Preview',
        component: EmailPreview,
        colSize: 12,
        dependencies: ['subject', 'body'],
        isAttribute: false,
      },
    },
  },
  {
    step: 3,
    title: 'Review & Send',
    showPrevButton: true,
    fields: {
      review: {
        type: 'custom',
        caption: 'Review',
        component: Review,
        colSize: 12,
        dependencies: ['mandate_filter', 'has_outstanding_invoice', 'has_email', 'last_sent_days', 'subject', 'body'],
        isAttribute: false,
      },
    },
  },
];

export default steps;
